import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';

import { DnaOligo } from 'src/models';
import { createResource, set } from 'src/core/redux/actions';
import { getErrorMessagesFromResponse } from 'src/utils';
import { STEPS_NAMESPACE_ACTION } from 'src/constants/forms';

const processApiData = (payload) => DnaOligo.processApiData(payload);

export default (WrappedComponent) => {
  const Component = ({ addToCart, validateData, ...ownProps }) => {
    const [actionErrors, setActionErrorsOnState] = React.useState([]);

    const setActionErrors = (errors) => setActionErrorsOnState(errors.map((error) => ({
      ...error,
      errorId: uuidv4(),
    })));

    const onAddToCart = async (payload) => {
      setActionErrors([]);

      const response = await addToCart(processApiData(payload));
      const errorMessages = await getErrorMessagesFromResponse(response);

      if (errorMessages?.length) {
        setActionErrors(errorMessages);
      }

      return !errorMessages?.length;
    };

    const onValidateData = async (payload) => {
      setActionErrors([]);

      const response = await validateData(processApiData(payload));

      const errorMessages = await getErrorMessagesFromResponse(response);

      if (errorMessages?.length) {
        setActionErrors(errorMessages);
      }

      return !errorMessages?.length;
    };

    return (
      <WrappedComponent
        {...{
          addToCart: onAddToCart,
          validateData: onValidateData,
          actionErrors,
          clearActionError: (message) => setActionErrors(
            actionErrors.filter((error) => error.errorId !== message.errorId)
          ),
          clearAllActionErrors: () => setActionErrors([]),
          ...ownProps,
        }}
      />
    );
  };

  Component.propTypes = {
    addToCart: PropTypes.func.isRequired,
    validateData: PropTypes.func.isRequired,
  };

  const mapDispatchToProps = (dispatch) => ({
    addToCart: (payload) => dispatch(createResource(DnaOligo)(payload)),
    validateData: (payload) => dispatch(createResource(DnaOligo)(payload, {
      url: DnaOligo.urls.validate,
    })),
    getDnaCartActiveStepState: () => dispatch(
      set(STEPS_NAMESPACE_ACTION, '', DnaOligo.getDnaCartActiveStepState())
    )
  });

  return connect(null, mapDispatchToProps)(Component);
};
